"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRedux = require("react-redux");

var _colors = require("HubStyleTokens/colors");

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedNumber = _interopRequireDefault(require("I18n/components/FormattedNumber"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UIExpandableSection = _interopRequireDefault(require("UIComponents/accordion/UIExpandableSection"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _getUsageTracker = _interopRequireDefault(require("pricing-pages-unified-ui/utils/getUsageTracker"));

var _CurrencySelectors = require("pricing-pages-unified-ui/selectors/CurrencySelectors");

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _reactRouterDom = require("react-router-dom");

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _PricingSelectors = require("../../selectors/PricingSelectors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin: 15px 0 0;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var QuestionContainer = _styledComponents.default.div.withConfig({
  displayName: "Question__QuestionContainer",
  componentId: "sc-1fb9lgq-0"
})(["margin-top:15px;margin-left:25px;margin-right:30px;background-color:", ";", ""], _colors.OLAF, _responsiveBreakpoints.default.phone(_templateObject()));

var QuestionOutlineBorder = (0, _styledComponents.default)(_UIExpandableSection.default).withConfig({
  displayName: "Question__QuestionOutlineBorder",
  componentId: "sc-1fb9lgq-1"
})(["border-width:0 0.5px 0.5px 1px;border-style:solid;border-color:", ";"], _colors.BATTLESHIP);

var Br = _styledComponents.default.br.withConfig({
  displayName: "Question__Br",
  componentId: "sc-1fb9lgq-2"
})(["line-height:40px;"]);

var Question = function Question(_ref) {
  var questionKey = _ref.questionKey,
      href = _ref.href,
      _ref$externalLink = _ref.externalLink,
      externalLink = _ref$externalLink === void 0 ? true : _ref$externalLink,
      history = _ref.history,
      calculatePrice = _ref.calculatePrice;
  var hasPricingAndPurchasingSucceeded = (0, _reactRedux.useSelector)(_LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector);
  var currencyCode = (0, _reactRedux.useSelector)(_CurrencySelectors.activeCurrencySelector);
  var calculatePriceAndItemConfig = (0, _reactRedux.useSelector)(_PricingSelectors.getCalculatePriceAndItemConfigSelector);

  var handleClickQuestion = function handleClickQuestion(question) {
    (0, _getUsageTracker.default)().track('faqClickQuestionExpansion', {
      questionKey: question
    });
  };

  var handleClickLink = function handleClickLink() {
    (0, _getUsageTracker.default)().track('externalLinkClick', {
      name: 'faq-click-link',
      url: href
    });

    if (!externalLink) {
      history.push(href);
      window.scrollTo(0, 0);
    }
  };

  var getExtraOptions = function getExtraOptions() {
    var options = {};
    options = {
      contentProfessionalOnboardingPrice: null,
      migrationFee: null,
      cmsHubMigrationFee: null,
      cmsHubProOnboarding: null,
      cmsHubEntOnboarding: null
    };

    if (hasPricingAndPurchasingSucceeded) {
      options.contentProfessionalOnboardingPrice = calculatePriceAndItemConfig({
        merchandiseId: _MerchandiseIds.SERVICE_CONTENT_PROFESSIONAL_ONBOARDING
      }).oneTimeFee.calculatedPrice;
      options.migrationFee = calculatePrice(_MerchandiseIds.SERVICE_FIRST_TIME_FULL_MIGRATION, [{
        merchandiseId: _MerchandiseIds.SERVICE_FIRST_TIME_FULL_MIGRATION,
        quantity: 21 // Needs to be 21 bc first 20 migrations are free

      }]).oneTimeFee.calculatedPrice;
      options.cmsHubProOnboarding = calculatePriceAndItemConfig({
        merchandiseId: _MerchandiseIds.SERVICE_CMS_PROFESSIONAL_ONBOARDING
      }).oneTimeFee.calculatedPrice;
      options.cmsHubEntOnboarding = calculatePriceAndItemConfig({
        merchandiseId: _MerchandiseIds.SERVICE_CMS_ENTERPRISE_ONBOARDING
      }).oneTimeFee.calculatedPrice;
    }

    return options;
  };

  var QuestionLink = function QuestionLink(_ref2) {
    var children = _ref2.children;
    return _react.default.createElement(_UILink.default, {
      external: externalLink,
      href: externalLink ? href : undefined,
      onClick: handleClickLink
    }, children);
  };

  return _react.default.createElement(QuestionContainer, null, _react.default.createElement(QuestionOutlineBorder, {
    titleText: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.faq." + questionKey + ".question"
    }),
    onClick: function onClick() {
      for (var _len = arguments.length, partialArgs = new Array(_len), _key = 0; _key < _len; _key++) {
        partialArgs[_key] = arguments[_key];
      }

      return handleClickQuestion.apply(void 0, [questionKey].concat(partialArgs));
    }
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.faq." + questionKey + ".answer_jsx",
    options: Object.assign({
      currencyCode: currencyCode
    }, getExtraOptions()),
    elements: {
      Link: QuestionLink,
      FormattedCurrency: _FormattedCurrency.default,
      FormattedNumber: _FormattedNumber.default,
      Br: Br,
      div: function div(_ref3) {
        var children = _ref3.children,
            rest = (0, _objectWithoutProperties2.default)(_ref3, ["children"]);
        return _react.default.createElement("div", rest, children);
      }
    }
  })));
};

Question.propTypes = {
  questionKey: _propTypes.default.string.isRequired,
  href: _propTypes.default.string,
  externalLink: _propTypes.default.bool,
  history: _propTypes.default.object,
  calculatePrice: _propTypes.default.func.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    calculatePrice: function calculatePrice(merchandiseId, itemConfigurations) {
      return (0, _PricingSelectors.calculatedPriceSelector)(state, {
        merchandiseId: merchandiseId,
        itemConfigurations: itemConfigurations
      });
    }
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Question));

exports.default = _default;
module.exports = exports.default;